import * as Yup                 from    'yup';
import { Tax, Type, Unit } from '../../../../../common/common.model';

export default Yup.object({
    name                    :   Yup.string()
                                .required('Name is required!'),
    type                    :   Yup.string()
                                .required('Type is required!')
                                .oneOf([Type.Goods, Type.Service], 'is not valid!'),
    sku                     :   Yup.string()
                                .required('SKU is required!'),
    unit                    :   Yup.string()
                                .required('Unit is required!')  
                                .oneOf([Unit.KG, Unit.BAG],' is not valid!'),
    rate                    :   Yup.number()
                                .required('Rate is required!')
                                .min(1, 'Rate shouldn\'t be 0')
                                .typeError('Rate should be number'),
    tax                     :   Yup.number()
                                .required('Tax is required!')
                                .oneOf([Tax.GST18, Tax.GST5,Tax.GST0],'Tax is not valid!'),
    hsnCode                 :   Yup.string()
                                .required('HSN Code is required!')
                                .min(8, 'HSN Code should be 8 characters')
                                .max(8, 'HSN Code should be 8 characters')
})
